<template>
<div class="box 1111">
   
<el-form :model="ruleForm" :rules="rules"  ref="ruleForm"  class="demo-ruleForm" label-position="left" >
    <el-form-item >
    <h1>识字管理系统</h1>
  </el-form-item>
  <el-form-item>
    <el-button-group class="chage_btn">
        <el-button :type="!stauts ?'primary':''" icon="el-icon-edit" @click="stauts=false,clear()">管理员</el-button>
        <el-button :type="stauts ?'primary':''" icon="el-icon-share" @click="stauts=true,clear()">教师端</el-button>
    </el-button-group>  
  </el-form-item>
  <div v-if="!stauts">
       <el-form-item  prop="user" class="nam">
    <el-input v-model="ruleForm.user" placeholder="请输入账号"></el-input>
  </el-form-item>
  <el-form-item  prop="password">
    <el-input v-model="ruleForm.password" placeholder="请输入密码" show-password></el-input>
  </el-form-item>
  </div>
 
    <div v-if="stauts">
    <el-form-item  prop="phone" class="nam">
    <el-input v-model="ruleForm.phone" placeholder="手机号"></el-input>
  </el-form-item>
  <el-form-item  prop="code" class="code">
      <div  class="code">
            <el-input v-model="ruleForm.code" placeholder="验证码" ></el-input>
    <el-button @click="sendcode()" :disabled="canClick" :loading="up">{{getcode}}</el-button>
      </div>
  
  </el-form-item>
      </div>
    <el-form-item  class="go_button">
   
     <el-button type="primary" @click="submitForm('ruleForm')" :disabled="changeStauts">登录</el-button>
  </el-form-item>
</el-form>
</div>
</template>

<script>
import login from '@/api/login.js'
import md5 from 'js-md5';
  export default {
    data() {
      return {
       stauts:false,
       changeStauts:true,
        ruleForm: {
          user:'',
          password:'',
          phone:'',
          code:''
        },
        up:false,
        totalTime:60,
        getcode:'发送验证码',
        canClick:true,
        phoneStauts:true,
        rules: {
          user: [
            {  message: '请输入账号', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          password: [
            { message: '请输入密码', trigger: 'change' }
          ],
            phone: [
            {  message: '请输入手机号', trigger: 'blur' },
            // {  message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],  code: [
            {  message: '请输入验证码', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
        
        }
      };
    },
    mounted () {
      // eslint-disable-next-line no-console
      console.log(this.$route.path)
    },
     updated () {
        if(this.ruleForm.user != '' && this.ruleForm.password !=''){
           this.changeStauts = false
        } else if(this.ruleForm.phone !='' && this.ruleForm.code !=''){
           this.changeStauts = false
        } else {
           this.changeStauts = true
        }
     
           if (this.ruleForm.phone !='') {
          this.canClick = false
        } else {
          this.canClick = true
        }
       
     },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
             
              // eslint-disable-next-line no-console
              console.log(this.ruleForm)
            // eslint-disable-next-line no-console
            if(!this.stauts){
                this.adminLogin()
                
            }else{
                this.teacherLogin()
               
            }
           
          } else {
            // eslint-disable-next-line no-console
            console.log('error submit!!');
            return false;
          }
        });
      },
      async adminLogin(){
        // online.adminLogin(this.ruleForm.name,this.ruleForm.password)
            let res  =await login.adminLogin({name:this.ruleForm.user,password:md5(this.ruleForm.password)})
            // eslint-disable-next-line no-console
            console.log(res.data.status)
            if(res.data.status=== 0){
               
                 sessionStorage.setItem('role',JSON.stringify({role:res.data.data.role})) 
                 sessionStorage.setItem('token',JSON.stringify({token:res.data.data.token}))
                 this.$router.push('/home')
            }
           
      },
      clear(){
       this.ruleForm= {
          user:'',
          password:'',
          phone:'',
          code:''
        }
        this.changeStauts = true
      },
        async teacherLogin(){
        // online.adminLogin(this.ruleForm.name,this.ruleForm.password)
            let res  =await login.teacherLogin({phone:this.ruleForm.phone,code:this.ruleForm.code})
            // eslint-disable-next-line no-console
            console.log(res.data.status)
            if(res.data.status=== 0){
                
                  sessionStorage.setItem('role',JSON.stringify({role:res.data.data.role})) 
                 sessionStorage.setItem('token', JSON.stringify({token:res.data.data.token}))
                 this.$router.push('/作文题目发放')
            }
           
      },
      async sendcode(){
          let res = await login.sendcode({phone:this.ruleForm.phone})
          this.up = true
          this.canClick = true
          let clock = window.setInterval(() => {
          this.totalTime--
          this.canClick = true
          console.log(this.canClick)
          this.getcode = this.totalTime + 's后可点击'
          if (this.totalTime < 0) {
            window.clearInterval(clock)
            this.getcode = '重新发送验证码'
            this.totalTime = 60
            this.canClick = false
            this.up = false
          } else if (res.data.status === 6001) {
            window.clearInterval(clock)
            this.getcode = '发送验证码'
            this.totalTime = 60
            this.canClick = false
            this.up = false
        }
        }, 1000)
          // eslint-disable-next-line no-console
          console.log(res)
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>
<style lang="scss" scoped>
.box{
     width: 100%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .demo-ruleForm{
         width: 350px;
    height: 360px;
        padding: 10px 30px;
        background: #fff; 
        border-radius: 2%; 
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .code{
           display: flex;
           .el-input{
             width: 223px;
               margin-right: 15px;
           }
        //   .el-button {
        //       width: 100%;
        //   }
        }
        .chage_btn{
           width: 100%;
              .el-button {
                width: 50%;
                margin-left: 0 !important;
            }
        }
        .go_button{
             .el-button {
            width: 100%;
            margin: 5px;
            margin-left: 0 !important;
        }
        }   
        
    }
    p{
    margin: 0 auto;
    }
}
</style>
